/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum Badge {
  Contractor = "Contractor",
}

export const BadgeDisplay: Record<Badge, string> = {
  [Badge.Contractor]: "Contractor",
};
